import { Injectable } from '@angular/core';

import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, CanLoad, Route } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url;

    return this.checkAccessToken(url, route);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    const url = '/${route.path}';

    return this.checkAccessToken(url);
  }

  checkAccessToken(url: string, route?): boolean {
    if (route && route.url && route.url.length > 0 && route.url[0].path === 'auth') {
      if (route.queryParams['session'] && route.queryParams['package']) {
        return true;
      } else {
        this.router.navigate(['/sign']);
      }
    }

    if (this.authService.isAuthenticated()) {
      return true;
    }

    this.router.navigate(['/finish']);

    return false;
  }
}
